<template>
  <v-container fluid>
    <v-card flat>
      <v-card-title v-if="standAloneMode">
        <v-toolbar>
          <v-icon color="brown">how_to_vote</v-icon>
          <v-toolbar-title class="font-weight-light">
            <v-row>
              <v-col>
                <div>&nbsp; Datos de la Tarjeta de Débito</div>
              </v-col>
            </v-row>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.stop="hideActiveSubTask"
            ><v-icon>close</v-icon></v-btn
          >
        </v-toolbar>
      </v-card-title>

      <!-- <div>{{datosTarjetaActual}}</div> -->

      <v-card-text>
        <!-- MUESTRO EL FORMULARIO SI NO HAY DATOS DE TARJETA O SI SE MARCA PARA CARGAR-->
        <v-row dense align="center" v-if="mostrarFormulario">
          <v-row v-if="!datosTarjetaActual">
            <h2>
              Actualmente no hay datos cargados. Puede cargarlos en el siguiente
              formulario:
            </h2>
          </v-row>

          <!-- <v-row dense> 
                  <v-col cols="10">
                    <v-radio-group row v-model="datosTarjetaActual.marcaId">
                      <v-radio label="VISA" :value="1"></v-radio>
                      <v-radio label="MasterCard" :value="2"></v-radio>
                      <v-radio label="Maestro" :value="3"></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row> -->

          <v-row dense>
            <v-col cols="10">
              <v-radio-group row v-model="datosTarjetaActual.tokenizadaPorId">
                <v-radio label="COIN" :value="1"></v-radio>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-radio
                      v-on="on"
                      label="CardCred"
                      :value="2"
                      :readonly="
                        !personaId ||
                        personaId == '00000000-0000-0000-0000-000000000000'
                      "
                    ></v-radio>
                  </template>
                  <span
                    v-if="
                      !personaId ||
                      personaId == '00000000-0000-0000-0000-000000000000'
                    "
                    >Primero se debe Completar el Legajo</span
                  >
                </v-tooltip>
              </v-radio-group>
            </v-col>
          </v-row>

          <!-- COIN  -->
          <v-row dense v-if="datosTarjetaActual.tokenizadaPorId == 1">
            <v-col>
              <app-formulario-tarjeta-coin
                v-on:token-generado="tokenGenerado($event)"
                :creditoId="creditoId"
                :empresaId="empresaId"
              ></app-formulario-tarjeta-coin>
            </v-col>
          </v-row>

          <!-- CarCRED -->
          <v-row dense v-if="datosTarjetaActual.tokenizadaPorId == 2">
            <div v-if="!standAloneMode && !modoInmediato">
              <v-alert v-if="!modoInmediato" color="pink" dark
                >ATENCION: En la ventana que aparecerá luego de Confirmar la
                Operación, debera seguir el Link para 'Tokenizar Tarjeta'
              </v-alert>
              <v-alert v-else color="pink" dark
                >ATENCION: Para tokenizar por este proveedor
              </v-alert>
            </div>
            <v-row v-if="standAloneMode || modoInmediato">
              <v-alert color="indigo" dark dense
                ><div class="caption">
                  Si hay tajetas que ya se registraron pero no aparecen en la
                  lista, presione aquí
                  <v-btn
                    @click="recargarTokenizadas"
                    color="primary"
                    x-small
                    dark
                    >Refrescar</v-btn
                  >
                </div></v-alert
              >

              <v-row
                v-if="
                  datosCardcred &&
                  datosCardcred.tarjetasTokenizadas &&
                  datosCardcred.tarjetasTokenizadas.filter((x) => x.activa)
                    .length == 0
                "
              >
                <!-- <v-col><div>{{datosTarjetaActual.datosCardcred}}</div></v-col> -->
                <v-alert
                  >No se encontraton tarjetas tokenizadas. Siga el link para
                  comenzar el proceso:</v-alert
                >
                <app-link-cardcred
                  v-if="datosCardcred.datosCardcred.urlDebito"
                  :info="
                    'Link CardCred (DEBITO) ' +
                    datosCardcred.datosCardcred.urlDebito
                  "
                  :solicitudId="creditoId"
                ></app-link-cardcred>
                <app-link-cardcred
                  v-if="datosCardcred.datosCardcred.urlCredito"
                  :info="
                    'Link CardCred (CREDITO) ' +
                    datosCardcred.datosCardcred.urlCredito
                  "
                  :solicitudId="creditoId"
                ></app-link-cardcred>
              </v-row>
              <v-row
                v-else-if="
                  datosCardcred &&
                  datosCardcred.tarjetasTokenizadas &&
                  datosCardcred.tarjetasTokenizadas.filter(
                    (x) => !modoInmediato || x.activa
                  ).length > 0
                "
              >
                <v-container>
                  <!-- <v-col><div>{{datosTarjetaActual.datosCardcred}}</div></v-col> -->
                  <v-alert color="blue" dark
                    >Hay
                    {{
                      datosCardcred.tarjetasTokenizadas.filter(
                        (x) => !modoInmediato || x.activa
                      ).length
                    }}
                    tarjeta/s tokenizada/s. Seleccione una para asociar los
                    débitos.</v-alert
                  >

                  <v-radio-group v-model="tarjetaCardCredSeleccionada">
                    <v-radio
                      v-for="item in datosCardcred.tarjetasTokenizadas.filter(
                        (x) => !modoInmediato || x.activa
                      )"
                      :key="item.id"
                      :label="item.numero + ' - ' + item.emisor"
                      :value="item"
                    ></v-radio>
                  </v-radio-group>

                  <v-alert
                    >Si requiere tokenizar una tarjeta nueva, siga el link para
                    comenzar el proceso:</v-alert
                  >
                  <app-link-cardcred
                    v-if="datosCardcred.datosCardcred.urlDebito"
                    :info="
                      'Link CardCred (DEBITO) ' +
                      datosCardcred.datosCardcred.urlDebito
                    "
                    :solicitudId="creditoId"
                  ></app-link-cardcred>
                  <app-link-cardcred
                    v-if="datosCardcred.datosCardcred.urlCredito"
                    :info="
                      'Link CardCred (CREDITO) ' +
                      datosCardcred.datosCardcred.urlCredito
                    "
                    :solicitudId="creditoId"
                  ></app-link-cardcred>
                </v-container>
              </v-row>
              <v-container v-else>
                <v-row>
                  <v-col>
                    <v-alert
                      >Proceso de tokenización inicial pendiente. Para comenzar
                      el proceso, presione el botón siguiente:</v-alert
                    >
                    <v-btn
                      color="pink"
                      dark
                      @click="altaClienteCardCred(creditoId)"
                      >Comenzar Proceso de Tokenizacion</v-btn
                    >
                  </v-col>
                </v-row>
              </v-container>
            </v-row>
          </v-row>

          <!-- <v-row no-gutters>
                    <v-col>
                        <v-text-field label="Nombre del Titular" outlined v-model="datosTarjetaActual.nombrePlastico"></v-text-field>
                    </v-col>
                </v-row> -->
        </v-row>

        <!-- lista de tarjetas -->
        <v-row no-gutters>
          <v-container fluid>
            <v-list>
              <v-list-item
                v-for="tarjeta in listaTarjetas.filter(
                  (x) => !modoInmediato || x.activa
                )"
                :key="tarjeta.tarjetaId"
              >
                <v-row dense>
                  <v-col>
                    <v-alert :color="tarjeta.baja ? 'grey' : 'green'" dense>
                      <v-row no-gutters dense>
                        <v-col>
                          <v-radio-group
                            row
                            v-model="tarjeta.activa"
                            dense
                            v-if="!tarjeta.baja"
                            :disabled="
                              !checkCanAccess('ap-puede-activar-tarjeta')
                            "
                          >
                            <v-radio
                              label="Activa"
                              :value="true"
                              @click="activar(tarjeta)"
                            ></v-radio>
                            <v-radio
                              label="Inactiva"
                              :value="false"
                              @click="desactivar(tarjeta)"
                            ></v-radio>
                            <v-spacer></v-spacer>
                            <v-chip
                              v-if="tarjeta.usadaEnCredito"
                              small
                              dark
                              color="indigo"
                              label
                            >
                              Asociada al Crédito</v-chip
                            >
                          </v-radio-group>
                        </v-col>
                      </v-row>
                      <div class="body-1">
                        Banco Emisor: {{ tarjeta.bancoEmisor }}
                      </div>
                      <div class="caption">
                        Últimos Digitos: {{ tarjeta.ultimosDigitos }}
                      </div>
                      <div class="caption">
                        Vencimiento: {{ tarjeta.mesVto }}/{{ tarjeta.anioVto }}
                      </div>
                      <v-divider />
                      <v-row>
                        <v-col>
                          Tokenizada Por: {{ tarjeta.tokenizadaPorDescripcion }}
                        </v-col>
                        <v-col
                          cols="4"
                          v-if="
                            tarjeta.tokenizadaPorDescripcion == 'CardCred' &&
                            tarjeta.operacionCarcred != 0
                          "
                        >
                          <v-btn
                            dark
                            color="red"
                            @click="anularCardCred(tarjeta)"
                            x-small
                            v-if="checkCanAccess('ap-puede-anular-tarjeta')"
                          >
                            Anular OP. CardCred
                          </v-btn>
                        </v-col>
                        <v-col cols="3" v-if="!tarjeta.baja">
                          <v-btn
                            dark
                            color="red"
                            @click="darBaja(tarjeta)"
                            x-small
                            v-if="checkCanAccess('ap-puede-anular-tarjeta')"
                          >
                            Dar de Baja
                          </v-btn>
                        </v-col>
                        <v-col cols="3" v-else> Dada de Baja </v-col>
                      </v-row>

                      <v-row
                        v-if="
                          tarjeta.formatoEnvioId == 1001 &&
                          tarjeta.operacionCarcred == 0 &&
                          tarjeta.usadaEnCredito
                        "
                        dense
                      >
                        <v-alert color="light-blue" dark dense>
                          <span class="caption"
                            >Esta tarjeta se tokenizó por CardCred, pero no se
                            se asoció/activó la operación. Presione el botón
                            Guardar Cambios para reintentar el proceso de
                            Activación en CardCred</span
                          >
                        </v-alert>
                        <!-- <v-btn @click="activarOperacionCardCred" color="info">Activar Operación CardCred</v-btn> -->
                      </v-row>
                    </v-alert>
                  </v-col>
                </v-row>
              </v-list-item>
            </v-list>

            <!-- <v-row no-gutters>
                        <v-col>
                            <v-radio-group row v-model="datosTarjetaActual.activa">
                                <v-radio label="Activa" :value="true"></v-radio>
                                <v-radio label="Inactiva" :value="false"></v-radio>
                                <v-spacer></v-spacer>
                                <v-btn dark  color="red" @click="darBaja" x-small v-if="checkCanAccess('ap-puede-anular-tarjeta')">
                                  Dar de Baja
                                </v-btn>
                            </v-radio-group>
                        </v-col>
                    </v-row>

                    <v-row dense>
                        <v-col>
                            <v-alert color="info" dark dense>
                            <div>
                            Banco Emisor: {{datosTarjetaActual.bancoEmisor}}
                            </div>
                            <div>
                            Últimos Digitos: {{datosTarjetaActual.ultimosDigitos}}
                            </div>
                            <div>
                            Vencimiento: {{datosTarjetaActual.mesVto}}/{{datosTarjetaActual.anioVto}}
                            </div>
                            <div>
                            Tokenizada Por: {{datosTarjetaActual.tokenizadaPorDescripcion}}
                            </div>                                               
                            </v-alert>
                        </v-col>
                    </v-row> -->

            <v-row no-gutters>
              <v-col>
                <v-switch
                  label="Agregar nueva Tarjeta"
                  v-model="mostrarFormulario"
                ></v-switch>
              </v-col>
            </v-row>
          </v-container>
        </v-row>
      </v-card-text>

      <v-divider v-if="standAloneMode"></v-divider>
      <v-card-actions v-if="standAloneMode">
        <v-btn color="blue darken-1" text @click.stop="hideActiveSubTask"
          >Cerrar</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn color="green " dark @click.stop="save">Guardar Cambios</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import Vue from "vue";
import { http } from "@/axios";
import { mapGetters, mapMutations } from "vuex";

export default {
  data: () => ({
    //datosTarjetaNueva: null,
    datosTarjetaActual: { marcaId: 0, tokenizadaPorId: 0, activa: true },
    listaTarjetas: [],
    mostrarFormulario: false,
    tarjetaCardCredSeleccionada: null,
    datosCardcred: null,
  }),
  props: {
    nuevoToken: {
      type: Boolean,
      default: true,
    },
    standAloneMode: {
      type: Boolean,
      default: true,
    },
    modoInmediato: {
      type: Boolean,
      default: false,
    },
    empresaId: {
      type: Number,
      required: true,
      default: null,
    },
    personaId: {
      type: String,
      required: false,
      default: null,
    },
    creditoId: {
      type: String,
      required: false,
    },
    tarjetaSeleccionada: {
      type: Object,
      required: false,
      default: function () {
        return {};
      },
    },
  },
  watch: {
    creditoId: function () {
      if (this.creditoId) {
        this.loadDatosTarjeta();
      }
    },
    "datosTarjetaActual.marcaId": function () {
      console.log("emit: datos-actualizados");
      this.$emit("datos-actualizados", this.datosTarjetaActual);
    },
    "datosTarjetaActual.tokenizadaPorId": function () {
      console.log("emit: datos-actualizados");
      this.$emit("datos-actualizados", this.datosTarjetaActual);
    },
    tarjetaCardCredSeleccionada: function () {
      // console.log('this.tarjetaCardCredSeleccionada');
      // console.log(this.tarjetaCardCredSeleccionada);
      // console.log(this.datosTarjetaActual);

      if (!this.tarjetaCardCredSeleccionada) return;

      Vue.set(this.tarjetaSeleccionada, "creditoId", this.creditoId);
      Vue.set(this.tarjetaSeleccionada, "personaId", this.personaId);
      Vue.set(
        this.tarjetaSeleccionada,
        "token",
        this.tarjetaCardCredSeleccionada.id
      );
      Vue.set(
        this.tarjetaSeleccionada,
        "mesVto",
        this.tarjetaCardCredSeleccionada.vencimiento.toString().substring(5, 7)
      );
      Vue.set(
        this.tarjetaSeleccionada,
        "anioVto",
        "20" +
          this.tarjetaCardCredSeleccionada.vencimiento
            .toString()
            .substring(2, 4)
      );
      Vue.set(
        this.tarjetaSeleccionada,
        "numero",
        this.tarjetaCardCredSeleccionada.numero
      );
      Vue.set(
        this.tarjetaSeleccionada,
        "numTarjetaTapado",
        this.tarjetaCardCredSeleccionada.numero
      );
      Vue.set(
        this.tarjetaSeleccionada,
        "bancoEmisor",
        this.tarjetaCardCredSeleccionada.emisor
      );
      if (this.datosTarjetaActual.datosCardcred)
        Vue.set(
          this.tarjetaSeleccionada,
          "clienteCardcred",
          this.datosTarjetaActual.datosCardcred.clienteId
        );
      Vue.set(
        this.tarjetaSeleccionada,
        "tokenizadaPorId",
        this.datosTarjetaActual.tokenizadaPorId
      );
      Vue.set(
        this.tarjetaSeleccionada,
        "tarjetaId",
        this.datosTarjetaActual.token
      );
      Vue.set(
        this.tarjetaSeleccionada,
        "activa",
        this.datosTarjetaActual.activa
      );

      //this.mostrarFormulario = false;
      this.isUpdate = false;
      this.datosTarjetaActual = this.tarjetaSeleccionada;
      this.datosTarjetaActual.ultimosDigitos =
        this.tarjetaSeleccionada.numTarjetaTapado.substring(
          this.tarjetaSeleccionada.numTarjetaTapado.length - 4
        );
      this.datosTarjetaActual.activa = true;
      this.datosTarjetaActual.tarjetaValidada = true;
      this.datosTarjetaActual.marcaId = 3;
      this.datosTarjetaActual.clienteCardcred =
        this.tarjetaSeleccionada.clienteCardcred;
      this.datosTarjetaActual.tokenizadaPorId =
        this.tarjetaSeleccionada.tokenizadaPorId;
      this.datosTarjetaActual.activa = this.tarjetaSeleccionada.activa;

      Vue.$log.debug(this.datosTarjetaActual);

      this.$emit("token-generado", this.datosTarjetaActual);
    },
  },
  computed: {
    ...mapGetters(["checkCanAccess"]),
  },
  async created() {
    if (this.creditoId) {
      await this.loadDatosTarjeta();
      await this.loadDatosCardCred();
    }
  },
  methods: {
    ...mapMutations([
      "hideActiveSubTask",
      "alertClear",
      "alertSuccess",
      "alertWarning",
      "alertError",
    ]),

    async loadDatosTarjeta() {
      this.loading = true;
      try {
        var result = await http.get(
          "creditos/datostarjeta?creditoId=" + this.creditoId
        );

        Vue.$log.debug(result);
        this.listaTarjetas = result;

        this.datosTarjetaActual = this.listaTarjetas.find(
          (x) => x.usadaEnCredito
        );
        if (!this.datosTarjetaActual) {
          this.datosTarjetaActual = {
            marcaId: 0,
            tokenizadaPorId: 0,
            activa: true,
          };
        } else {
          this.mostrarFormulario = !this.datosTarjetaActual.tarjetaValidada;
        }
        this.isUpdate = true;

        Vue.$log.debug(this.datosTarjetaActual);
      } catch (error) {
        // Error
        Vue.$log.error(error);
      }
      this.loading = false;
    },
    async loadDatosCardCred() {
      this.loading = true;
      try {
        var result = await http.get(
          "personas/getDatosCardCred?personaId=" +
            this.personaId +
            "&empresaId=" +
            this.empresaId
        );

        Vue.$log.debug(result);
        this.datosCardcred = result;
      } catch (error) {
        // Error
        Vue.$log.error(error);
      }
      this.loading = false;
    },
    async tokenGenerado(datosTarjeta) {
      if (!datosTarjeta.token || datosTarjeta.token == "") {
        this.alertError(
          "Atención (Reintentar Tokenización): se produjo un error al recuperar el Token. Los datos devueltos por COIN son: " +
            JSON.stringify(datosTarjeta)
        );
        return;
      }

      Vue.set(this.tarjetaSeleccionada, "creditoId", this.creditoId);
      Vue.set(this.tarjetaSeleccionada, "token", datosTarjeta.token);
      Vue.set(this.tarjetaSeleccionada, "mesVto", datosTarjeta.mesVto);
      Vue.set(this.tarjetaSeleccionada, "anioVto", datosTarjeta.anioVto);
      Vue.set(
        this.tarjetaSeleccionada,
        "numero",
        datosTarjeta.numTarjetaTapado
      );
      Vue.set(
        this.tarjetaSeleccionada,
        "bancoEmisor",
        datosTarjeta.bancoEmisor
      );

      console.log("datos tarjeta");
      console.log(datosTarjeta);

      this.mostrarFormulario = false;

      this.isUpdate = false;
      datosTarjeta.marcaId = this.datosTarjetaActual.marcaId;

      this.datosTarjetaActual = datosTarjeta;
      this.datosTarjetaActual.ultimosDigitos =
        datosTarjeta.numTarjetaTapado.substring(
          datosTarjeta.numTarjetaTapado.length - 4
        );
      this.datosTarjetaActual.activa = true;
      this.datosTarjetaActual.tokenizadaPorId = 1;
      this.datosTarjetaActual.tokenizadaPorDescripcion = "COIN";
      this.datosTarjetaActual.tarjetaValidada = true;
      this.datosTarjetaActual.numero = this.datosTarjetaActual.numTarjetaTapado;

      this.datosTarjetaActual.personaId = this.personaId;
      this.datosTarjetaActual.empresaId = this.empresaId;

      Vue.$log.debug(this.datosTarjetaActual);

      // guardo la tarjeta asociada al cliente
      try {
        if (this.personaId != "00000000-0000-0000-0000-000000000000") {
          this.loading = true;
          var res = await http.post(
            "personas/altatarketatokenizada",
            JSON.stringify({ parametros: this.datosTarjetaActual })
          );

          console.log(res);

          this.datosTarjetaActual.tarjetaId = res;
        }

        this.listaTarjetas.push(this.datosTarjetaActual);
        this.activar(this.datosTarjetaActual);

        this.$emit("token-generado", datosTarjeta);
      } catch (error) {
        // Error
        Vue.$log.error(error);
        this.alertError(error);
      }
      this.loading = false;
    },
    validar() {
      if (!this.datosTarjetaActual) {
        this.alertWarning("No se pudieron actualizar los datos.");
        return false;
      }

      if (this.mostrarFormulario && this.datosTarjetaActual.marcaId == 3) {
        if (this.tarjetaCardCredSeleccionada == null) {
          this.alertWarning(
            "Por favor, seleccione una tarjeta para asociar el débito."
          );
          return false;
        }
      }

      /* if(this.isUpdate && !this.datosTarjetaActual)
        {
            this.alertWarning('No se pudieron actualizar los datos.');
            return false;
        }
        else if(!this.isUpdate && !this.datosTarjetaNueva)
        {
            this.alertWarning('Debe cargar los datos de la tarjeta antes de guardar.');
            return false;
        } */
      return true;
    },
    setData() {
      Vue.set(this.tarjetaSeleccionada, "creditoId", this.creditoId);
      Vue.set(this.tarjetaSeleccionada, "personaId", this.personaId);

      Vue.set(this.tarjetaSeleccionada, "token", this.datosTarjetaActual.token);
      Vue.set(
        this.tarjetaSeleccionada,
        "mesVto",
        this.datosTarjetaActual.mesVto
      );
      Vue.set(
        this.tarjetaSeleccionada,
        "anioVto",
        this.datosTarjetaActual.anioVto
      );
      Vue.set(
        this.tarjetaSeleccionada,
        "bancoEmisor",
        this.datosTarjetaActual.bancoEmisor
      );

      Vue.set(
        this.tarjetaSeleccionada,
        "activa",
        this.datosTarjetaActual.activa
      );
      Vue.set(
        this.tarjetaSeleccionada,
        "marcaId",
        this.datosTarjetaActual.marcaId
      );
      Vue.set(
        this.tarjetaSeleccionada,
        "clienteCardcred",
        this.datosTarjetaActual.clienteCardcred
      );
      Vue.set(
        this.tarjetaSeleccionada,
        "tokenizadaPorId",
        this.datosTarjetaActual.tokenizadaPorId
      );
      Vue.set(
        this.tarjetaSeleccionada,
        "tarjetaId",
        this.datosTarjetaActual.tarjetaId
      );

      if (this.isUpdate)
        Vue.set(
          this.tarjetaSeleccionada,
          "numTarjetaTapado",
          this.datosTarjetaActual.ultimosDigitos
        );
      else
        Vue.set(
          this.tarjetaSeleccionada,
          "numTarjetaTapado",
          this.datosTarjetaActual.numTarjetaTapado
        );
    },
    async save() {
      if (!this.validar()) return;
      this.loading = true;

      try {
        this.setData();
        Vue.$log.debug("TARJETA SELECCIONADA");
        Vue.$log.debug(this.tarjetaSeleccionada);

        await http.post(
          "creditos/updatedatostarjeta",
          JSON.stringify({ parametros: this.tarjetaSeleccionada })
        );
        this.alertSuccess("Los cambios han sido registrados");

        // recargo
        this.loadDatosTarjeta();
      } catch (error) {
        // Error
        Vue.$log.error(error);
        this.alertError(error);
      }
      this.loading = false;
    },
    async altaClienteCardCred() {
      this.loading = true;
      try {
        this.setData();

        const formData = new FormData();

        formData.append("personaId", this.personaId);
        formData.append("creditoId", this.creditoId);
        formData.append("empresaId", this.empresaId);

        await http.post("personas/altacardcred", formData);
        this.alertSuccess(
          "Los cambios han sido registrados. Se recargará la ventana."
        );

        // recargo
        const seleccionProveedor = this.datosTarjetaActual.tokenizadaPorId;

        await this.loadDatosTarjeta();
        if (this.modoInmediato) {
          await this.loadDatosCardCred();
          this.datosTarjetaActual.tokenizadaPorId = seleccionProveedor;
        }
      } catch (error) {
        // Error
        Vue.$log.error(error);
        this.alertError(error);
      }
      this.loading = false;
    },
    async recargarTokenizadas() {
      this.loading = true;
      try {
        await http.get(
          "external/refrescartokenizadas/" +
            this.personaId +
            "/" +
            this.creditoId
        );

        this.alertSuccess(
          "Los cambios han sido registrados. Se recargará la ventana."
        );

        // recargo
        const seleccionProveedor = this.datosTarjetaActual.tokenizadaPorId;
        await this.loadDatosTarjeta();
        await this.loadDatosCardCred();
        this.tarjetaCardCredSeleccionada = null;
        this.datosTarjetaActual.tokenizadaPorId = seleccionProveedor;
      } catch (error) {
        // Error
        Vue.$log.error(error);
        this.alertError(error);
      }
      this.loading = false;
    },
    async darBaja(tarjeta) {
      this.loading = true;

      let res = await this.$dialog.prompt({
        text: "Ingrese el Motivo de la Baja",
        title: "Baja de Tarjeta",
      });
      if (!res) return;

      try {
        await http.delete(
          "creditos/deletetarjeta/" + tarjeta.tarjetaId + "/" + res
        );
        this.alertSuccess("La tarjeta ha sido dada de baja");

        await this.loadDatosTarjeta();
      } catch (error) {
        // Error
        Vue.$log.error(error);
        this.alertError(error);
      }
      this.loading = false;
    },
    async anularCardCred() {
      this.loading = true;

      // let res = await this.$dialog.prompt({
      //   text: 'Ingrese el Motivo de la Baja',
      //   title: 'Baja de Tarjeta',
      // });
      // if(!res) return;

      try {
        await http.post(
          "external/cardcred/anular",
          JSON.stringify({ creditoId: this.creditoId })
        );
        this.alertSuccess("La operación ha sido anulada en CardCred");

        await this.loadDatosTarjeta();
      } catch (error) {
        // Error
        Vue.$log.error(error);
        this.alertError(error);
      }
      this.loading = false;
    },
    activar(tarjeta) {
      for (let i = 0; i < this.listaTarjetas.length; i++) {
        const tar = this.listaTarjetas[i];
        if (tar.tarjetaId != tarjeta.tarjetaId) {
          tar.activa = false;
          tar.usadaEnCredito = false;
        }
      }
      tarjeta.usadaEnCredito = true;
      tarjeta.tarjetaValidada = true;

      this.datosTarjetaActual = tarjeta;
      this.$emit("datos-actualizados", this.datosTarjetaActual);
    },
    desactivar(tarjeta) {
      for (let i = 0; i < this.listaTarjetas.length; i++) {
        const tar = this.listaTarjetas[i];
        if (tar.tarjetaId != tarjeta.tarjetaId) {
          tar.activa = false;
          tar.usadaEnCredito = false;
        }
      }
      tarjeta.usadaEnCredito = true;
      tarjeta.tarjetaValidada = true;

      this.datosTarjetaActual = tarjeta;
      this.$emit("datos-actualizados", this.datosTarjetaActual);
      console.log(tarjeta);
    },
  },
};
</script>
